import { takeLatest, call, put } from 'redux-saga/effects'
import { createScormInstance } from 'api/administration/blocks/Create'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/blocks.action'

async function handleCreateScormBlock(data: any) {
  return createScormInstance(data)
}

async function getList(lessonId: number) {
  return lessonBlocksList(lessonId)
}

function* newScormBlockEffectSaga(action: any) {
  try {
    const { data } = action
    const result = yield call(handleCreateScormBlock, data)
    yield put(fromActions.Actions.createBlockInstanceSuccess(result))
    const {
      block_instance: { lesson_id },
    } = data
    const blocks = yield call(getList, lesson_id)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(blocks))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* createScormWatcherSaga() {
  yield takeLatest(fromActions.SCORM_BLOCK_CREATE, newScormBlockEffectSaga)
}
